<template>
    <div id="footerContent">
        <div class="footerContent center-block">
            <img :src="url" alt="" class="img-responsive center-block">
        </div>

    </div>
</template>

<script>
    export default {
        name: "footerContent",
        props:[
            'url'
        ]
    }
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/common/footerContent.vue